/**
 * Havenlytics blocks — single editor bundle.
 *
 * Registers every Havenlytics block from one editor script so the block-editor
 * dependencies (wp-block-editor, wp-components, …) load once. Frontend markup is
 * produced server-side by each block's PHP render callback.
 *
 * @package
 * @since   3.5.0
 */

import './editor.scss';

import './property-archive';
import './property-search';
import './agents';
import './agency';
import './featured-properties';
import './property-carousel';
import './property-map';
import './authentication';
import './dashboard';
import './saved-properties';
import './property-inquiry';
